import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState } from './types'
import { useHistory, useParams } from 'react-router-dom'
import { useAlert } from 'react-alert'
import DatePicker from 'react-datepicker'
import moment from 'moment'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default () => {
  const [icon, setIcon] = useState<File>()
  const [title, setTitle] = useState<string>('')
  const [theme, setTheme] = useState<string>('')
  const [indexNumber, setIndexNumber] = useState<number>(0)
  const [selectedModuleId, setSelectedModuleId] = useState<string>('')
  const [timeToStudy, setTimeToStudy] = useState<number>(0)
  const [isFirst, setIsFirst] = useState<boolean>(false)
  const [isLast, setIsLast] = useState<boolean>(false)
  const [isFree, setIsFree] = useState<boolean>(false)
  const [availableAt, setAvailableAt] = useState<Date>(new Date())
  const [position, setPosition] = useState<number>(0)
  const [assistantCaption, setAssistantCaption] = useState<string>('')

  const history = useHistory()
  const { id } = useParams<{ id: string }>()

  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    themes,
    modules,
    isModulesFetching,
    isThemesFetching,
    isCreateComplete,
    error,
  } = useSelector(
    (state: { adminLessonCreate: InitialState }) => state.adminLessonCreate
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.fetchModules(id))
    dispatch(actions.fetchThemes(id))
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (isCreateComplete) {
      history.push(`/admin/courses/${id}/lessons`)
    }
  }, [isCreateComplete])

  const onChangeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value)
  }

  const onChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]
      setIcon(file)
    }
  }

  const onChangeTheme = (event: ChangeEvent<HTMLSelectElement>) => {
    setTheme(event.currentTarget.value)
  }

  const handleCreateLesson = () => {
    dispatch(
      actions.createLesson(
        id,
        selectedModuleId,
        title,
        icon,
        theme,
        assistantCaption,
        indexNumber,
        timeToStudy,
        isFirst,
        isLast,
        isFree,
        moment(availableAt),
        position
      )
    )
  }

  const onChangeModule = (event: ChangeEvent<HTMLSelectElement>) => {
    setSelectedModuleId(event.currentTarget.value)
  }

  const onChangeIndexNumber = (event: ChangeEvent<HTMLInputElement>) => {
    setIndexNumber(parseInt(event.currentTarget.value))
  }

  const onChangeTimeToStudy = (event: ChangeEvent<HTMLInputElement>) => {
    setTimeToStudy(parseInt(event.currentTarget.value))
  }

  const onChangePosition = (event: ChangeEvent<HTMLInputElement>) => {
    setPosition(parseInt(event.currentTarget.value))
  }

  const onChangeAssistantCaption = (event: ChangeEvent<HTMLInputElement>) => {
    setAssistantCaption(event.target.value)
  }

  const onChangeIsFirst = (event: ChangeEvent<HTMLInputElement>) => {
    setIsFirst(event.target.checked)
  }

  const onChangeIsLast = (event: ChangeEvent<HTMLInputElement>) => {
    setIsLast(event.currentTarget.checked)
  }

  const onChangeIsFree = (event: ChangeEvent<HTMLInputElement>) => {
    setIsFree(event.currentTarget.checked)
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Создание урока</h2>
        <label htmlFor={'title'}>Название урока:</label>
        <br />
        <input
          id={'title'}
          placeholder={'Введите название урока'}
          value={title}
          onChange={onChangeTitle}
          style={{ marginBottom: 10, width: 200 }}
          required={true}
          autoComplete={'off'}
        />
        <br />
        <span style={{ display: 'block', marginBottom: 10 }}>
          Выбранная иконка:
          <br />
          <b>{icon?.name || 'Иконка не выбрана'}</b>
        </span>
        <label
          htmlFor={'icon'}
          style={{
            cursor: 'pointer',
            border: '1px solid grey',
            borderRadius: 6,
            padding: '0 6px',
            marginBottom: 10,
            display: 'block',
            width: 200,
            textAlign: 'center',
          }}
        >
          Выбрать иконку
        </label>
        <input
          onChange={onChangeFile}
          id={'icon'}
          type={'file'}
          style={{ display: 'none' }}
        />
        <label htmlFor={'theme'}>Тема:</label>
        <br />
        {themes.length ? (
          <select
            value={theme}
            onChange={onChangeTheme}
            style={{ marginBottom: 10, width: 200 }}
          >
            <option value="" disabled>
              Выберите тему
            </option>
            {themes.map(theme => (
              <option value={theme.theme_id} key={theme.theme_id}>
                {theme.title}
              </option>
            ))}
          </select>
        ) : isThemesFetching ? (
          <>
            <span>Загрузка тем...</span>
            <br />
          </>
        ) : null}
        <br />
        <h3>Модули</h3>
        {isModulesFetching ? (
          <span>Загрузка модулей...</span>
        ) : (
          <>
            <span style={{ display: 'block', marginBottom: 5 }}>
              Выберите модуль
            </span>
            <select
              style={{ width: 200 }}
              value={selectedModuleId}
              onChange={onChangeModule}
            >
              <option disabled={true} value={''}>
                Выберите модуль
              </option>
              {modules.map(module => (
                <option key={module.module_id} value={module.module_id}>
                  {module.title}
                </option>
              ))}
            </select>
          </>
        )}
        {selectedModuleId ? (
          <div style={{ marginTop: 15 }}>
            <label style={{ display: 'block', marginBottom: 5 }}>
              Порядковый номер:
            </label>
            <input
              type={'number'}
              value={indexNumber}
              style={{ width: 200, marginBottom: 10 }}
              placeholder={'Укажите порядковый номер'}
              onChange={onChangeIndexNumber}
            />
            <label style={{ display: 'block', marginBottom: 5 }}>
              Время на изучение:
            </label>
            <input
              type={'number'}
              value={timeToStudy}
              style={{ width: 200 }}
              placeholder={'Укажите время на изучение'}
              onChange={onChangeTimeToStudy}
            />
            <br />
            <span style={{ display: 'block', marginBottom: 10, fontSize: 12 }}>
              Если не указано, будет использовано 90
            </span>
            <label style={{ width: 200, display: 'block', marginBottom: 10 }}>
              Текст помощника
              <input
                value={assistantCaption}
                type={'text'}
                onChange={onChangeAssistantCaption}
              />
            </label>
            <label style={{ width: 200, display: 'block', marginBottom: 10 }}>
              Первый урок <input type={'checkbox'} onChange={onChangeIsFirst} />
            </label>
            <label style={{ width: 200, display: 'block', marginBottom: 10 }}>
              Последний урок{' '}
              <input type={'checkbox'} onChange={onChangeIsLast} />
            </label>
            <label style={{ display: 'block', marginBottom: 10 }}>
              Свободный к прохождению{' '}
              <input type={'checkbox'} onChange={onChangeIsFree} />
            </label>
            <label style={{ display: 'block', marginBottom: 5 }}>
              Время открытия урока
            </label>
            <DatePicker
              locale={'ru'}
              selected={availableAt}
              onChange={(date: Date) => setAvailableAt(date)}
              showTimeSelect={true}
              dateFormat={'Pp'}
            />
            <label style={{ display: 'block', marginBottom: 5, marginTop: 5 }}>
              Позиция:
            </label>
            <input
              value={position}
              type={'number'}
              style={{ width: 200 }}
              placeholder={'Укажите время на изучение'}
              onChange={onChangePosition}
            />
          </div>
        ) : null}
        <br />
        <br />
        <button
          disabled={!selectedModuleId && !theme}
          onClick={handleCreateLesson}
        >
          Создать
        </button>
        <br />
        <br />
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
